import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask, round2Decimals } from "../Components/Items";
import numeroALetra from "../Components/numeroALetra";
import { formatQRTotal } from "../Components/RoundQRDecimals";
// import { dineroDisabledMask } from "../Components/Items";
// import xmlToJson from "../Components/xmlToJson";
moment.locale("es");

const ticketPdf = (data, imprimirSoloUna) => {
  const empresa = data.respuestaFactura.empresa
  const quitarImpuestosRemisiones = empresa?.quitarImpuestosRemisiones || false;
  const cliente = data.respuestaFactura.dataSat.Receptor;
  const dataSat = data.respuestaFactura.dataSat
  const logo = empresa.logo.base64Completa;
  const conceptos = dataSat.Conceptos;
  const idKiosko = data.idKiosko || data.kioskoid;
  const numeroRemision = data?.remisionNumero;
  const serieRemision = data?.remisionSerie;
  const logoBiwo = data?.logoBiwo?.base64Completa;
  let vendedor;

  if (empresa.vendedorVentas) {
    vendedor = data.vendedor.nombre + " " + data.vendedor.apellidoPaterno + " " + data.vendedor.apellidoMaterno;
  }

  // Observaciones de la venta, solo si se marcó imprimirlas
  const observacionesTicket = (data.imprimirObservaciones && data.observaciones)
    ? [
      {
        margin: [0, 5, 0, 0],
        table: {
          widths: ["100%"],
          headerRows: 1,
          body: [
            [
              {
                text: "OBSERVACIONES",
                alignment: "center",
                bold: true,
                fontSize: 8,
                margin: [0, 3, 0, 0],
              },
            ],
          ],
        },
        layout: {
          defaultBorder: false,
        },
      },
      {
        margin: [0, 0, 0, 0],
        table: {
          widths: ["100%"],
          body: [
            [
              {
                text: data.observaciones,
                alignment: "center",
                fontSize: 7,
              },
            ],
          ],
        },
        layout: {
          defaultBorder: false,
          paddingTop: () => 0,
          paddingBottom: () => 0,
        },
      },
    ]
    : [];

  let totalImpuestosParaDescuentoTodo = 0

  // Genera dinámicamente las filas para la tabla de conceptos
  // Genera dinámicamente las filas para la tabla de conceptos
  const filasConceptos = [];

  conceptos.forEach((concepto) => {
    if (quitarImpuestosRemisiones && !data.factura) {
      let totalImpuestoConcepto = 0;
      concepto.Impuestos?.Traslados?.forEach((valueImpuesto) => {
        totalImpuestoConcepto += valueImpuesto.Importe ? Number(valueImpuesto.Importe) : 0;
      });
      const factorDescuento = (concepto.Descuento / concepto.ValorUnitario);
      const impuestosFinalesConcepto = round2Decimals(totalImpuestoConcepto / (1 - factorDescuento));
      totalImpuestosParaDescuentoTodo += round2Decimals(impuestosFinalesConcepto * factorDescuento);

      // Agregar ambas filas por separado
      filasConceptos.push([
        {
          text: concepto.Descripcion,
          style: "tProductsBody",
          fontSize: 6,
          colSpan: 5,
          alignment: "left"
        },
        {}, {}, {}, {}
      ]);

      filasConceptos.push([
        {
          text: concepto.CodigoBarras || '',
          style: "tProductsBody",
          fontSize: 7,
        },
        {
          text: concepto.Cantidad,
          style: "tProductsBody",
          alignment: "center",
          fontSize: 6,
        },
        {
          text: concepto.Unidad ? concepto.Unidad.slice(0, 3) : '',
          style: "tProductsBody",
          alignment: "center",
          fontSize: 6,
        },
        {
          text: parseFloat(
            Number(concepto.ValorUnitario) + (impuestosFinalesConcepto / Number(concepto.Cantidad))
          ).toFixed(2),
          style: "tProductsBody",
          alignment: "right",
          fontSize: 6,
        },
        {
          text: parseFloat(
            Number(concepto.Importe) + impuestosFinalesConcepto
          ).toFixed(2),
          style: "tProductsBody",
          alignment: "right",
          fontSize: 6,
        },
      ]);
    } else {

      // Agregar ambas filas por separado
      filasConceptos.push([
        {
          text: concepto.Descripcion,
          style: "tProductsBody",
          fontSize: 6,
          colSpan: 5,
          alignment: "left"
        },
        {}, {}, {}, {}
      ]);

      filasConceptos.push([
        {
          text: concepto.CodigoBarras || '',
          style: "tProductsBody",
          fontSize: 7,
        },
        {
          text: concepto.Cantidad,
          style: "tProductsBody",
          alignment: "center",
          fontSize: 6,
        },
        {
          text: concepto.Unidad ? concepto.Unidad.slice(0, 3) : '',
          style: "tProductsBody",
          alignment: "center",
          fontSize: 6,
        },
        {
          text: parseFloat(concepto.ValorUnitario).toFixed(2),
          style: "tProductsBody",
          alignment: "right",
          fontSize: 6,
        },
        {
          text: parseFloat(concepto.Importe).toFixed(2),
          style: "tProductsBody",
          alignment: "right",
          fontSize: 6,
        },
      ]);
    }
  });

  const nuevoArrayImpFL = Array.isArray(dataSat.Impuestos.Traslados) ?
    [...dataSat.Impuestos.Traslados, ...(dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["implocal:TrasladosLocales"] || [])]
    :
    [...(dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["implocal:TrasladosLocales"] || [])]

  // Definir orden personalizado
  const ordenImpuestos = ["IVA 0%", "IVA 16%", "IEPS 6%", "IEPS 7%", "IEPS 9%"];

  // Ordenar el array antes del map
  const nuevoArrayImpFLOdenado = [...nuevoArrayImpFL].sort((a, b) => {
    const nombreA = a.Impuesto === "002"
      ? `IVA ${round2Decimals(a.TasaOCuota * 100)}%`
      : a.Impuesto === "003"
        ? `IEPS ${round2Decimals(a.TasaOCuota * 100)}%`
        : a["@ImpLocTrasladado"];
    const nombreB = b.Impuesto === "002"
      ? `IVA ${round2Decimals(b.TasaOCuota * 100)}%`
      : b.Impuesto === "003"
        ? `IEPS ${round2Decimals(b.TasaOCuota * 100)}%`
        : b["@ImpLocTrasladado"];

    return ordenImpuestos.indexOf(nombreA) - ordenImpuestos.indexOf(nombreB);
  });

  const impuestosTotales = quitarImpuestosRemisiones && !data.factura ? [] : nuevoArrayImpFLOdenado.map(
    (valueImpuesto, indexImpuesto) => {
      let nombre = "";
      if (valueImpuesto.Impuesto === "002") {
        nombre = "IVA";
      } else if (valueImpuesto.Impuesto === "003") {
        nombre = "IEPS";
      } else {
        nombre = valueImpuesto["@ImpLocTrasladado"]
      }

      if (valueImpuesto.TipoFactor === "Tasa") {
        nombre = nombre + " " + round2Decimals(valueImpuesto.TasaOCuota * 100) + "%";
      } else if (valueImpuesto.TipoFactor === "Cuota") {
        nombre = nombre + " $" + round2Decimals(valueImpuesto.TasaOCuota);
      }

      return [
        { text: nombre, style: "tTotals", colSpan: 2, fontSize: 8, },
        {},
        { text: dineroDisabledMask(valueImpuesto.Importe || valueImpuesto["@Importe"] || 0), style: "tTotals", colSpan: 2, fontSize: 8, alignment: "right", },
        {},
      ];
    }
  );

  let agregarDescuentos = []
  const totalDescuentos = (Number(dataSat.Descuento) + totalImpuestosParaDescuentoTodo)

  if (totalDescuentos) {
    agregarDescuentos = [
      [
        { text: "DESCUENTO: ", style: "tTotals", colSpan: 2, fontSize: 8, },
        {},
        { text: dineroDisabledMask(totalDescuentos), style: "tTotals", colSpan: 2, fontSize: 8, alignment: "right", },
        {},
      ],
    ]
  }

  const nuevoArrayRetFL = Array.isArray(dataSat.Impuestos.Retenciones) ?
    [...dataSat.Impuestos.Retenciones, ...(dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["implocal:RetencionesLocales"] || [])]
    :
    [...(dataSat?.Complemento?.Any?.find(item => item['implocal:ImpuestosLocales'])?.['implocal:ImpuestosLocales']?.["implocal:RetencionesLocales"] || [])]

  const retencionesTotales = quitarImpuestosRemisiones && !data.factura ? [] : nuevoArrayRetFL.map(
    (valueRetencion) => {
      let nombre = "Retención ";
      if (valueRetencion.Impuesto === "001") {
        nombre = nombre + "ISR";
      } else if (valueRetencion.Impuesto === "002") {
        nombre = nombre + "IVA";
      } else {
        nombre = valueRetencion["@ImpLocRetenido"]
      }

      return [
        { text: nombre, style: "tTotals", colSpan: 2, fontSize: 8, },
        {},
        { text: dineroDisabledMask(valueRetencion.Importe || valueRetencion["@Importe"] || 0), style: "tTotals", colSpan: 2, fontSize: 8, alignment: "right", },
        {},
      ];
    }
  )

  let cancelado = {}
  if (data.estado === 0) {
    if (data.facturaId){
      cancelado = { watermark: { text: 'FACTURADO', color: 'GRAY', opacity: 0.3, bold: true, italics: false, angle: -50, fontSize: 50 } }
    } else {
      cancelado = { watermark: { text: 'CANCELADO', color: 'GRAY', opacity: 0.3, bold: true, italics: false, angle: -50, fontSize: 50 } }
    }
  }

  // Función para obtener la descripción del tipo de relación
  const getDescripcionTipoRelacion = (tipo) => {
    switch (tipo) {
      case "01": return "01 - Nota de crédito de los documentos relacionados";
      case "02": return "02 - Nota de débito de los documentos relacionados";
      case "03": return "03 - Devolución de mercancía sobre facturas o traslados previos";
      case "04": return "04 - Sustitución de los CFDI previos";
      case "05": return "05 - Traslados de mercancías facturados previamente";
      case "06": return "06 - Factura generada por los traslados previos";
      case "07": return "07 - CFDI por aplicación de anticipo";
      default: return tipo;
    }
  };
  let tablaCfdiRelacionados = [];

  if (Array.isArray(data.relacionesCFDI)) {

    // Agregamos un separador y un título para la sección
    tablaCfdiRelacionados.push(
      { text: 'CFDI RELACIONADOS', alignment: 'center', bold: true, fontSize: 7, margin: [0, 3, 0, 0] }
    );

    // Para cada relación, agregamos su tipo y UUID de forma vertical
    data.relacionesCFDI.forEach(relacion => {
      const tipoRelacionTexto = getDescripcionTipoRelacion(relacion.tipoRelacion);

      tablaCfdiRelacionados.push({
        text: `Tipo: ${tipoRelacionTexto}`,
        fontSize: 6,
        alignment: 'left',
        margin: [0, 3, 0, 0]
      });

      tablaCfdiRelacionados.push({
        text: `UUID: ${relacion.uuid}`,
        fontSize: 5,
        alignment: 'left'
      });
    });
    tablaCfdiRelacionados.push(
      { text: '', alignment: 'center', fontSize: 8, margin: [0, 0, 0, 3] },

    )
  }



  if (data.factura) {

    const totalqr = formatQRTotal(dataSat.Total)
    let cadena8 = data.respuestaFactura.data.selloCFDI
    cadena8 = cadena8.slice(-8)

    const linkqr = `https://verificacfdi.facturaelectronica.sat.gob.mx/default.aspx?&id=${data.respuestaFactura.data.uuid}&re=${empresa.rfc}&rr=${dataSat.Receptor.Rfc}&tt=${totalqr}&fe=${cadena8}`

    return {
      pageSize: { width: 206, height: "auto" }, // 80 mm de ancho, altura ajustable
      pageMargins: [10, 10, 10, 10],
      ...cancelado,
      /*footer: {
        image: 'logoBiwo', alignment: 'center', width: 80, height: 30
      },*/
      content: [
        {
          image: logo,
          fit: [141.73, 56.692],
          alignment: "center",
        },
        {
          text: empresa.nombreComercial ? empresa.nombreComercial : (empresa.persona ? empresa.nombre : empresa.nombre + " " + empresa.apellidoPaterno + " " + empresa.apellidoMaterno),
          style: "header",
          margin: [0, 10, 0, 0],
          alignment: "center",
          fontSize: 12,
        },
        {
          text: empresa.rfc,
          style: "header",
          alignment: "center",
          fontSize: 6,
        },
        {
          text: empresa.calle + " " + empresa.numeroCalle + " " + (empresa.numeroInterior ? empresa.numeroInterior : " "),
          style: "header",
          alignment: "center",
          fontSize: 6,
        },
        {
          text: empresa.colonia.nombre + " " + empresa.colonia.cp + " " + empresa.municipio.nombre + " " + empresa.municipio.nombre + " " + empresa.pais.nombre,
          style: "header",
          alignment: "center",
          fontSize: 6,
        },
        {
          text: `Regimen Fiscal: (${empresa.regimenFiscal.c_RegimenFiscal}) ${empresa.regimenFiscal.descripcion}`,
          style: "header",
          alignment: "center",
          fontSize: 6,
        },

        { text: `Nº Factura - ${dataSat.Serie} - ${dataSat.Folio} ${numeroRemision ? ` /  ${serieRemision || ''} - ${numeroRemision}` : ''}`, margin: [5, 3, 0, 3], style: "header", fontSize: 10, },

        {
          margin: [0, 2, 0, 0],
          table: {
            widths: ["100%"], // Solo dos columnas
            body: [
              ...((empresa.vendedorVentas && vendedor) ? [[
                {
                  text: "Vendedor: " + vendedor, style: "tHeaderValue", fontSize: 6
                },
              ]] : []),
              [
                { text: cliente.Nombre, style: "tHeaderValue", fontSize: 6, },
              ],
              [
                { text: cliente.Rfc, style: "tHeaderValue", fontSize: 6, },
              ],
              [
                { text: `(${dataSat.usoDeCFDI.c_UsoCFDI}) ${dataSat.usoDeCFDI.descripcion} `, style: "tHeaderValue", fontSize: 6, },
              ],
              [
                { text: `(${dataSat.formaDePago.c_FormaPago}) ${dataSat.formaDePago.descripcion} `, style: "tHeaderValue", fontSize: 6, },
              ],
              [
                {
                  text: dataSat.MetodoPago === "PUE" ? "PUE - Pago en una sola exhibición" : "PPD - Pago en parcialidades o diferido ",
                  style: "tHeaderValue",
                  fontSize: 6,
                },
              ],
              [
                { text: `Fecha de venta: ${moment(dataSat.Fecha).format('DD/MM/YYYY')}`, style: "tHeaderValue", fontSize: 6, },
              ],
              [
                { text: `Hora de venta: ${moment(dataSat.Fecha).format('HH:mm:ss')}`, style: "tHeaderValue", fontSize: 6, }],
              [
                { text: dataSat.LugarExpedicion, style: "tHeaderValue", fontSize: 6, },
              ],
            ],
          },
          layout: {
            defaultBorder: false,
            paddingTop: () => 0,
            paddingBottom: () => 0,
          },
        },

        {
          margin: [0, 2, 0, 0],
          table: {
            widths: ["36%", "14%", "10%", "20%", "20%"], // Ajuste de proporciones
            headerRows: 2,
            body: [
              // Encabezado de la tabla
              [
                {
                  text: "TICKET DE COMPRA",
                  colSpan: 5,
                  style: "tTitleHeader",
                  alignment: "center",
                  fontSize: 12,
                  margin: [0, 3, 0, 0],
                },
                {},
                {},
                {},
                {},
              ],
              [
                {
                  text: "DESCRIPCIÓN",
                  style: "tProductsHeader",
                  alignment: "center",
                  fontSize: 7,
                },
                {
                  text: "CANT",
                  style: "tProductsHeader",
                  alignment: "center",
                  fontSize: 7,
                },
                {
                  text: "UN",
                  style: "tProductsHeader",
                  alignment: "center",
                  fontSize: 7,
                },
                {
                  text: "PRECIO",
                  style: "tProductsHeader",
                  alignment: "right",
                  fontSize: 7,
                },
                {
                  text: "TOTAL",
                  style: "tProductsHeader",
                  alignment: "right",
                  fontSize: 7,
                },
              ],

              ...filasConceptos,

              // Línea final o total
              // [
              //   { text: "", colSpan: 1, border: [false, false, false, false] },
              //   {
              //     text: "Total:",
              //     margin: [0, 2, 0, 0],
              //     style: "tTotalLabel",
              //     alignment: "right",
              //     bold: true,
              //     fontSize: 7,
              //     colSpan: 2,
              //   },
              //   {},
              //   {
              //     text: dineroDisabledMask(dataSat.SubTotal),
              //     margin: [0, 2, 0, 0],
              //     style: "tTotalValue",
              //     alignment: "right",
              //     bold: true,
              //     fontSize: 7,
              //     colSpan: 2,
              //   },
              //   {},
              // ],
            ],
          },

          layout: {
            hLineWidth: function (i, node) {
              return (i !== 0 && i !== 1 && i % 2 === 0) ? 1 : 0;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function () {
              return "#adaaaa";
            },
            paddingTop: function (i, node) {
              return 0;
            },
          },
        },

        {
          margin: [0, 0, 0, 0],
          table: {
            widths: ["25%", "35%", "15%", "25%"],
            body: [
              [
                { text: "SUBTOTAL: ", style: "tTotals", colSpan: 2, fontSize: 8, },
                {},
                { text: dineroDisabledMask(dataSat.SubTotal), style: "tTotals", colSpan: 2, fontSize: 8, alignment: "right", },
                {},
              ],
              ...agregarDescuentos,
              ...impuestosTotales,
              ...retencionesTotales,
              [
                { text: "TOTAL: ", style: "tTotals", colSpan: 2, fontSize: 8, },
                {},
                { text: dineroDisabledMask(dataSat.Total), style: "tTotals", colSpan: 2, fontSize: 8, alignment: "right", },
                {},
              ],
              [
                {},
                {},
                {},
                {},
              ],
              [
                {
                  text: numeroALetra(dataSat.Total, dataSat.Moneda),
                  style: "tProductsBody",
                  colSpan: 4,
                  fontSize: 8,
                },
                {},
                {},
                {},
              ],
            ],
          },
          layout: "noBorders",
        },

        ...(dataSat.MetodoPago !== "PUE"
          ? [
            {
              margin: [0, 20, 0, 0],
              stack: [
                {
                  columns: [
                    {
                      width: "*",
                      stack: [
                        {
                          text: "____________________________________________________________",
                          alignment: "center",
                          fontSize: 6,
                          margin: [0, 2, 0, 0],
                        },
                        {
                          text: "Nombre y firma del cliente",
                          alignment: "center",
                          fontSize: 6,
                          margin: [0, 2, 0, 0],
                        },
                      ],
                    },
                  ],
                },
                {
                  text: "Acepto recibir la mercancía y pagar conforme a las condiciones de crédito.",
                  alignment: "center",
                  fontSize: 6,
                  margin: [0, 10, 0, 0],
                },
              ],
            },
          ]
          : []),

        {
          stack: [
            ...(idKiosko
              ? [
                {
                  qr: `https://biwo.online/kiosko?kiosko_id=${idKiosko}`,
                  fit: 90,
                  alignment: "center",
                  eccLevel: "Q",
                  margin: [0, 5, 0, 5],
                },
              ]
              : []),
            {
              text: idKiosko ? `Link: https://biwo.online/kiosko?kiosko_id=${idKiosko}` : "",
              style: "text",
              alignment: "center",
              fontSize: 6,
            },
            {
              text: idKiosko ? `Folio: ${idKiosko}` : "",
              style: "text",
              alignment: "center",
              fontSize: 6,
            },
            {
              text: idKiosko ? "Escanee para ver su factura." : "",
              style: "text",
              alignment: "center",
            },
          ],
        },
        ...observacionesTicket,
        ...(empresa.textoAdicionalTicketFactura
          ? [
            {
              style: "tableExample",
              table: {
                widths: ["100%"],
                body: [
                  [
                    {
                      text: empresa.textoAdicionalTicketFactura,
                      style: "textoAdicionalTicket",
                      border: [false, false, false, false],
                      margin: [0, 0, 0, 0],
                    },
                  ],
                ],
              },
              layout: {
                defaultBorder: false,
                hLineWidth: function (i, node) {
                  return i === 0 || i === node.table.body.length ? 1 : 1;
                },
                vLineWidth: function (i, node) {
                  return i === 0 || i === node.table.widths.length ? 1 : 1;
                },
                hLineColor: function (i, node) {
                  return "#adaaaa";
                },
                vLineColor: function (i, node) {
                  return "#adaaaa";
                },
                hLineStyle: function (i, node) {
                  if (i === 0 || i === node.table.body.length) {
                    return null;
                  }
                  return { dash: { length: 2, space: 1 } };
                },
                vLineStyle: function (i, node) {
                  if (i === 0 || i === node.table.widths.length) {
                    return null;
                  }
                  return { dash: { length: 2 } };
                },
              },
            },
          ]
          : []),
        ...tablaCfdiRelacionados,



        {
          text: "Folio Fiscal:",
          style: "text",
          alignment: "justify",
          fontSize: 7,
        },
        {
          text: data.respuestaFactura.data.uuid,
          style: "text",
          fontSize: 4,
        },
        {
          text: "Sello digital CFDI:",
          style: "text",
          alignment: "justify",
          fontSize: 7,
        },
        {
          text: data.respuestaFactura.data.selloCFDI,
          style: "text",
          fontSize: 4,
        },
        {
          text: "Numero de serie del Certificado de Sello digital:",
          style: "text",
          alignment: "justify",
          fontSize: 7,
        },
        {
          text: data.respuestaFactura.data.noCertificadoCFDI,
          style: "text",
          fontSize: 4,
        },
        {
          text: "Numero de serie del Certificado de Sello digital del SAT:",
          style: "text",
          alignment: "justify",
          fontSize: 7,
        },
        {
          text: data.respuestaFactura.data.noCertificadoSAT,
          style: "text",
          fontSize: 4,
        },
        {
          text: "Cadena Original del complemento de certificación Digital SAT:",
          style: "text",
          alignment: "justify",
          fontSize: 7,
        },
        {
          text: data.respuestaFactura.data.cadenaOriginalSAT,
          style: "text",
          fontSize: 4,
        },
        {
          text: "Sello Digital del SAT:",
          style: "text",
          alignment: "justify",
          fontSize: 7,
        },
        {
          text: data.respuestaFactura.data.selloSAT,
          style: "text",
          fontSize: 4,
        },
        {
          stack: [
            {
              qr: linkqr,
              fit: 115,
              alignment: "center",
              eccLevel: "Q",
              margin: [0, 5, 0, 5],
            },
          ]
        },
        {
          text: "Sello Digital del CFDI:",
          style: "text",
          alignment: "justify",
          fontSize: 7,
        },
        {
          text: data.respuestaFactura.data.selloCFDI,
          style: "text",
          fontSize: 4,
        },
        ...(logoBiwo ? [
          {
            image: logoBiwo,
            fit: [141.73, 56.692],
            alignment: "center",
          },
        ] : [])
      ],
      styles: {
        header: {
          bold: true,
          fontSize: 15,
        },
      },
      defaultStyle: {
        fontSize: 12,
      },
    };

  } else if (!data.factura) {
    return {
      pageSize: { width: 206, height: "auto" }, // 80 mm de ancho, altura ajustable
      pageMargins: [10, 10, 10, 10],
      ...cancelado,

      content: [
        {
          image: logo,
          fit: [141.73, 56.692],
          alignment: "center",
        },
        {
          text: empresa.nombreComercial ? empresa.nombreComercial : (empresa.persona ? empresa.nombre : empresa.nombre + " " + empresa.apellidoPaterno + " " + empresa.apellidoMaterno),
          style: "header",
          margin: [0, 10, 0, 0],
          alignment: "center",
          fontSize: 12,
        },
        {
          text: empresa.rfc,
          style: "header",
          alignment: "center",
          fontSize: 6,
        },
        {
          text: empresa.calle + " " + empresa.numeroCalle + " " + (empresa.numeroInterior ? empresa.numeroInterior : " "),
          style: "header",
          alignment: "center",
          fontSize: 6,
        },
        {
          text: empresa.colonia.nombre + " " + empresa.colonia.cp + " " + empresa.municipio.nombre + " " + empresa.municipio.nombre + " " + empresa.pais.nombre,
          style: "header",
          alignment: "center",
          fontSize: 6,
        },
        {
          text: `Regimen Fiscal: (${empresa.regimenFiscal.c_RegimenFiscal}) ${empresa.regimenFiscal.descripcion}`,
          style: "header",
          alignment: "center",
          fontSize: 6,
        },

        { text: `Nº Remision - ${dataSat.Serie} - ${dataSat.Folio}`, style: "header", margin: [5, 3, 0, 3], fontSize: 10, },
        {
          margin: [0, 0, 0, 0],
          table: {
            widths: ["100%"],
            body: [
              ...((empresa.vendedorVentas && vendedor) ? [[
                {
                  text: "Vendedor: " + vendedor, style: "tHeaderValue", fontSize: 6
                },
              ]] : []),
              [
                { text: cliente.Nombre, style: "tHeaderValue", fontSize: 6, },
              ],
              [
                { text: cliente.Rfc, style: "tHeaderValue", fontSize: 6, },
              ],
              [
                { text: `(${dataSat.formaDePago.c_FormaPago}) ${dataSat.formaDePago.descripcion} `, style: "tHeaderValue", fontSize: 6, },
              ],
              [
                {
                  text: dataSat.MetodoPago === "PUE" ? "PUE - Pago en una sola exhibición" : "PPD - Pago en parcialidades o diferido ",
                  style: "tHeaderValue",
                  fontSize: 6,
                },
              ],
              [
                { text: `Fecha de venta: ${moment(dataSat.Fecha).format('DD/MM/YYYY')}`, style: "tHeaderValue", fontSize: 6, },
              ],
              [
                { text: `Hora de venta: ${moment(dataSat.Fecha).format('HH:mm:ss')}`, style: "tHeaderValue", fontSize: 6, }],
            ],
          },
          layout: {
            defaultBorder: false,
            paddingTop: () => 0,
            paddingBottom: () => 0,
          },
        },

        {
          margin: [0, 0, 0, 0],
          table: {
            widths: ["36%", "14%", "10%", "20%", "20%"], // Ajuste de proporciones
            headerRows: 2,
            body: [
              // Encabezado de la tabla
              [
                {
                  text: "TICKET DE COMPRA",
                  colSpan: 5,
                  style: "tTitleHeader",
                  alignment: "center",
                  fontSize: 12,
                  margin: [0, 3, 0, 0],
                },
                {},
                {},
                {},
                {},
              ],
              [
                {
                  text: "DESCRIPCIÓN",
                  style: "tProductsHeader",
                  alignment: "center",
                  fontSize: 7,
                },
                {
                  text: "CANT",
                  style: "tProductsHeader",
                  alignment: "center",
                  fontSize: 7,
                },
                {
                  text: "UN",
                  style: "tProductsHeader",
                  alignment: "center",
                  fontSize: 7,
                },
                {
                  text: "PRECIO",
                  style: "tProductsHeader",
                  alignment: "right",
                  fontSize: 7,
                },
                {
                  text: "TOTAL",
                  style: "tProductsHeader",
                  alignment: "right",
                  fontSize: 7,
                },
              ],
              // Primera fila de datos
              ...filasConceptos,
              // [
              //   { text: "", colSpan: 1, border: [false, false, false, false] },
              //   {
              //     text: "Total:",
              //     margin: [0, 2, 0, 0],
              //     style: "tTotalLabel",
              //     alignment: "right",
              //     bold: true,
              //     fontSize: 7,
              //     colSpan: 2,
              //   },
              //   {},
              //   {
              //     text: dineroDisabledMask((quitarImpuestosRemisiones && !data.factura) ? (Number(dataSat.Total) + totalDescuentos) : dataSat.SubTotal),
              //     margin: [0, 2, 0, 0],
              //     style: "tTotalValue",
              //     alignment: "right",
              //     bold: true,
              //     fontSize: 7,
              //     colSpan: 2,
              //   },
              //   {},
              // ],
            ],
          },

          layout: {
            hLineWidth: function (i, node) {
              return (i !== 0 && i !== 1 && i % 2 === 0) ? 1 : 0;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
            hLineColor: function () {
              return "#adaaaa";
            },
            paddingTop: function (i, node) {
              return 0;
            },
          },
        },

        {
          margin: [0, 0, 0, 0],
          table: {
            widths: ["25%", "35%", "15%", "25%"],
            body: [
              [
                { text: "SUBTOTAL: ", style: "tTotals", colSpan: 2, fontSize: 8, },
                {},
                { text: dineroDisabledMask((quitarImpuestosRemisiones && !data.factura) ? (Number(dataSat.Total) + totalDescuentos) : dataSat.SubTotal), style: "tTotals", colSpan: 2, fontSize: 8, alignment: "right", },
                {},
              ],
              ...agregarDescuentos,
              ...impuestosTotales,
              ...retencionesTotales,
              [
                { text: "TOTAL: ", style: "tTotals", colSpan: 2, fontSize: 8, },
                {},
                { text: dineroDisabledMask(dataSat.Total), style: "tTotals", colSpan: 2, fontSize: 8, alignment: "right", },
                {},
              ],
              [
                {},
                {},
                {},
                {},
              ],
              [
                {
                  text: numeroALetra(dataSat.Total, dataSat.Moneda),
                  style: "tProductsBody",
                  colSpan: 4,
                  fontSize: 8,
                },
                {},
                {},
                {},
              ],
            ],
          },
          layout: "noBorders",
        },

        ...(dataSat.MetodoPago !== "PUE"
          ? [
            {
              margin: [0, 20, 0, 0],
              stack: [
                {
                  columns: [
                    {
                      width: "*",
                      stack: [
                        {
                          text: "____________________________________________________________",
                          alignment: "center",
                          fontSize: 6,
                          margin: [0, 2, 0, 0],
                        },
                        {
                          text: "Nombre y firma del cliente",
                          alignment: "center",
                          fontSize: 6,
                          margin: [0, 2, 0, 0],
                        },
                      ],
                    },
                  ],
                },
                {
                  text: "Acepto recibir la mercancía y pagar conforme a las condiciones de crédito.",
                  alignment: "center",
                  fontSize: 6,
                  margin: [0, 10, 0, 0],
                },
              ],
            },
          ]
          : []),

        {
          stack: [
            ...(idKiosko
              ? [
                {
                  qr: `https://biwo.online/kiosko?kiosko_id=${idKiosko}`,
                  fit: 90,
                  alignment: "center",
                  eccLevel: "Q",
                  margin: [0, 5, 0, 5],
                },

              ]
              : []),
            {
              text: idKiosko ? `Link: https://biwo.online/kiosko?kiosko_id=${idKiosko}` : "",
              style: "text",
              alignment: "center",
              fontSize: 6,
            },
            {
              text: idKiosko ? `Folio: ${idKiosko}` : "",
              style: "text",
              alignment: "center",
              fontSize: 6,
            },
            {
              text: idKiosko ? "Escane para realizar su factura." : "",
              style: "text",
              alignment: "center",
            },
          ],
        },
        ...observacionesTicket,
        ...(empresa.textoAdicionalTicketRemision
          ? [
            {
              style: "tableExample",
              table: {
                widths: ["100%"],
                body: [
                  [
                    {
                      text: empresa.textoAdicionalTicketRemision,
                      style: "textoAdicionalTicket",
                      border: [false, false, false, false],
                      margin: [0, 0, 0, 0],
                    },
                  ],
                ],
              },
              layout: {
                defaultBorder: false,
                hLineWidth: function (i, node) {
                  return i === 0 || i === node.table.body.length ? 1 : 1;
                },
                vLineWidth: function (i, node) {
                  return i === 0 || i === node.table.widths.length ? 1 : 1;
                },
                hLineColor: function (i, node) {
                  return "#adaaaa";
                },
                vLineColor: function (i, node) {
                  return "#adaaaa";
                },
                hLineStyle: function (i, node) {
                  if (i === 0 || i === node.table.body.length) {
                    return null;
                  }
                  return { dash: { length: 2, space: 1 } };
                },
                vLineStyle: function (i, node) {
                  if (i === 0 || i === node.table.widths.length) {
                    return null;
                  }
                  return { dash: { length: 2 } };
                },
              },
            },
          ]
          : []),
        ...(logoBiwo ? [
          {
            image: logoBiwo,
            fit: [141.73, 56.692],
            alignment: "center",
          },
        ] : [])

      ],
      styles: {
        header: {
          bold: true,
          fontSize: 15,
        },
        textoAdicionalTicket: {
          fontSize: 8,
          alignment: "center"
        }
      },

      defaultStyle: {
        fontSize: 12,
      },
    };

  }

};

export default ticketPdf;
